// Functions
import VerifyToken from "../../config/verifyToken";
// Components
import Header from "../../components/header";
import { Main } from "../generalStyle";
import StickyLogo from "../../components/stickyLogo";
import EvaluationsView from "../../components/rgsICU/evaluations";

const Evaluations = () => (
  <>
    {VerifyToken()}
    <Header />
    <Main>
      <StickyLogo />
      <EvaluationsView />
    </Main>
  </>
);

export default Evaluations;
